/* eslint-disable react/no-children-prop */
import { CloseOutlined, ExclamationCircleFilled } from "@ant-design/icons";
import { useMutation, useQuery } from "@apollo/client";
import {
  Badge,
  Button,
  Checkbox,
  Dropdown,
  Input,
  List,
  message,
  Modal,
  Popover,
  Radio,
  Tag,
  Tooltip,
  Pagination,
} from "antd";
import dayjs from "dayjs";
import { isEmpty, isUndefined, orderBy } from "lodash";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { UserContext } from "../../../amplify/authenticator-provider";
import { colorCode } from "../../../config";
import { UPDATE_LEAD_ARCHIVE_STATUS } from "../../../graphql/mutation";
import useLang from "../../../hooks/useLang";
import ArchiveIcon from "../../../icons/js/ArchiveIcon";
import FilterIcon from "../../../icons/js/FilterIcon";
import RestoreArchiveIcon from "../../../icons/js/RestoreArchive";
import SortIcon from "../../../icons/js/SortIcon";
import { parseTimestamp } from "../../../library/utils";
import { getCacheApi, setSelectedLeadPhone } from "../../../redux/slices/apiCacheSlice";
import { AccessPermissionAction } from "../../../library/constants";
import { checkAccessPermission } from "../../../library/helpers";
import {
  addQuickFilter,
  removeMyConversationFlag,
  removeQuickFilter,
  resetLeadFilters,
  setLeadSortOrder,
  setSearchRedux,
  changeMessageOpportunity,
} from "../../../redux/slices/leadSlice";
import AntdIconV4 from "../../../utils/antdIcon";
import CustomLabel from "../../commonComponents/label";
import { getOpportunityStatusPath, statusColor } from "./engagementHelpers";
import LeadFilterBreadcrumbs from "./leadFilterBreadcrumbs";
import LeadList from "./leadList";
import DownIcon from "../../../icons/DownIcon";
import useBrowserExt from "../../../hooks/useBrowserExt";
import { useWindowSize } from "../../../hooks/personalizedHooks";
import { GET_OPPORTUNITY_STATUS } from "../../../graphql/query";

const LeadListContainer = props => {
  const {
    setShowLeadSection,
    selectedLead,
    leadsLoading,
    leadList,
    setLeadList,
    variables,
    leadCount,
    setVariables,
    setSelectedLead,
    setMessageFilters,
    messageFilters,
    sourcesData,
    searchKey,
    handleSearch,
    setSearchKey,
    activeOpp,
    setActiveOpp,
    opportunityList,
    timeReference,
    setOpportunityList,
    setFilterApplied,
    handleOppFilter,
    handleStatusFilter,
    leadStatus,
    selectedStatus,
    setSelectedStatus,
    openAppointmentPopup,
    handleAppointmentModalClose,
    setSelectedLeadId,
    setbtnClicked,
    setActiveLeadId,
    handleScrollOnMovement,
    changePage,
    setQueryString = () => {},
    isFromChatbot = false,
    handleLeadListVisible,
    IsLeadListVisible,
    spinner,
    campaignFilters,
    queryString,
    entityId,
    eventId,
    handleLeadListDrawer = () => {},
    onClose,
    setAttachments,
    refetchLeads,
    setmessageText = () => {},
    setSummaryVisible,
    handleUnpinLead = () => {},
    selectedLeadsFromLeadCenter = [],
    getDuplicateLeads = () => {},
    getMergedLead = () => {},
    removeMergedLead = () => {},
  } = props;
  const { isBrowserExt } = useBrowserExt();
  const { width, height } = useWindowSize();
  const quickFilters = [
    {
      title: "Inbox",
      backgroundColor: "processing",
      value: "RESPONDED",
    },
    {
      title: "Sent",
      backgroundColor: "success",
      value: "WAITING_FOR_REPLY",
    },
    {
      title: "Archived",
      backgroundColor: "error",
      value: "NO_RESPONSE_NEEDED",
    },
  ];
  const urlParams = new URLSearchParams(window.location.search);
  const presetLeadFilter = urlParams.get("presetFilter");

  const { user, modal, newLead, setNewLead, addnewLead, setAddNewLead } = useContext(UserContext);
  const dispatch = useDispatch();
  const [lang] = useLang();
  const selectedLeadPhoneReduxData = useSelector(state => getCacheApi(state, "selectedLeadPhone"));
  const { quickFilters: selectedQuickFilters, userFilters } = useSelector(
    state => state.lead.filters
  );
  const { leads, leadSort, search } = useSelector(state => state.lead);
  const [visible, setVisible] = useState(false);
  const [leadData, setLeadData] = useState([]);
  const [showAll, setShowAll] = useState([]);
  const [noResponseNeededLoading, setNoResponseNeededLoading] = useState(false);
  const [opportunityStatusList, setOpportunityStatusList] = useState([]);

  const { loading: opportunityStatusLoader } = useQuery(GET_OPPORTUNITY_STATUS, {
    variables: {
      fetchAll: true,
      locationIds: (sessionStorage?.getItem("currentLocationId") || "").includes(",")
        ? sessionStorage
            ?.getItem("currentLocationId")
            ?.split(",")
            .map(el => +el)
        : [+sessionStorage?.getItem("currentLocationId")],
    },
    onCompleted: resp => {
      setOpportunityStatusList(resp.getOpportunityStatus || []);
    },
  });

  const [setLeadAsNoResponseNeeded] = useMutation(UPDATE_LEAD_ARCHIVE_STATUS, {
    onCompleted: resp => {
      if (resp?.updateLeadArchiveStatus?.statusCode === 200) {
        message.success(resp?.updateLeadArchiveStatus?.message || "");
        setNoResponseNeededLoading(false);
        refetchLeads();
      } else {
        message.error(resp?.updateLeadArchiveStatus?.message || "");
      }
    },
  });
  const handleVisibleChange = () => {
    setVisible(!visible);
  };

  const filterCount =
    (variables?.campaignIds || []).length +
    (variables.search && variables.search !== "undefined" ? 1 : 0) +
    (presetLeadFilter && presetLeadFilter !== "undefined" ? 1 : 0) +
    (selectedStatus || []).length +
    userFilters.length;

  useEffect(() => {
    if (newLead !== null && addnewLead) {
      const array = () => {
        const temp = structuredClone(leads);
        newLead.fullName = newLead.full_name;
        temp.unshift(newLead);
        return [...temp];
      };
      setLeadList(array());
      setAddNewLead(false);
      setNewLead(null);
    }
  }, [newLead, addnewLead]);

  useEffect(() => {
    if (showAll?.length === 0) {
      const temp = leadData?.map((item, i) => true);
      setShowAll(temp);
    }
  }, [leadData]);
  useEffect(() => {
    setSearchKey(selectedLeadPhoneReduxData);
  }, [selectedLeadPhoneReduxData]);

  useEffect(() => {
    if (!window.location.search) dispatch(setSelectedLeadPhone({ selectedLeadPhone: searchKey }));
    // return () => dispatch(setSelectedLeadPhone({ selectedLeadPhone: "" }));
  }, [searchKey]);

  useEffect(() => {
    return () => dispatch(setSelectedLeadPhone({ selectedLeadPhone: "" }));
  }, []);

  useEffect(() => {
    setLeadData(leadList);
  }, [leadList]);

  const setSearch = search => {
    setVariables({ ...variables, page: 1 });
    dispatch(setSearchRedux(search));
  };
  const SortOptionsContainer = () => {
    const [sortOption, setsortOption] = useState(leadSort);
    // prioritySortOrder
    return (
      <>
        <h3>Sort options</h3>
        <Radio.Group
          value={sortOption}
          onChange={e => {
            setsortOption(e.target.value);
            dispatch(setLeadSortOrder(e.target.value));
          }}
          className="flex flex-col"
        >
          <Radio value="default">Default</Radio>
          <Radio value="lastMessage">Most Recent Message</Radio>
        </Radio.Group>
      </>
    );
  };

  const backgroundColor = id => {
    switch (id) {
      case "MY_CONVERSATIONS":
        return "bg-[#EDE9FE] text-[#7C3AED]";
      case "NO_RESPONSE_NEEDED":
        return "bg-[#FEF2F2] text-[#DC2626]";
      case "ENGAGED":
        return "bg-green-100 text-green-600";
      case "UNCONTACTED":
        return "bg-[#FEF3C7] text-[#D97706]";
      case "RESPONDED":
        return "bg-orange-100 text-orange-600";
      case "WAITING_FOR_REPLY":
        return "bg-blue-100 text-blue-600";
      default:
        return "";
    }
  };
  const renderFilters = leadStatus.map(item => ({
    label: (
      <Checkbox
        onClick={e => e.stopPropagation()}
        onChange={e => {
          if (setVariables) {
            setVariables({
              ...variables,
              page: 1,
            });
          }
          if (e.target.checked) {
            dispatch(addQuickFilter(item.id));
          } else {
            dispatch(removeQuickFilter(item.id));
          }
        }}
        checked={selectedQuickFilters.includes(item.id)}
      >
        <span onClick={e => e.stopPropagation()} className={`${backgroundColor(item.id)}`}>
          {item.name}
        </span>
      </Checkbox>
    ),
    key: item.id,
  }));

  const canMergeOppor = checkAccessPermission(AccessPermissionAction.MERGE_LEADS_OPPS);

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <TopLeadFilters
        lang={lang}
        search={search}
        isFromChatbot={isFromChatbot}
        setSearchKey={setSearchKey}
        setQueryString={setQueryString}
        handleSearch={handleSearch}
        setSearch={setSearch}
        SortOptionsContainer={SortOptionsContainer}
        visible={visible}
        handleVisibleChange={handleVisibleChange}
        variables={variables}
        setVariables={setVariables}
        opportunityList={opportunityList}
        activeOpp={activeOpp}
        handleOppFilter={handleOppFilter}
        setActiveOpp={setActiveOpp}
        setShowLeadSection={setShowLeadSection}
        selectedStatus={selectedStatus}
        setSelectedStatus={setSelectedStatus}
        leadStatus={leadStatus}
        handleStatusFilter={handleStatusFilter}
        campaignFilters={campaignFilters}
        queryString={queryString}
        entityId={entityId}
        eventId={eventId}
        filterCount={filterCount}
        renderFilters={renderFilters}
        dispatch={dispatch}
        selectedQuickFilters={selectedQuickFilters}
        backgroundColor={backgroundColor}
      />

      <div className="overflow-y-auto flex-grow list-border-bottom">
        <List
          className="cursor-pointer"
          itemLayout="horizontal"
          loading={leadsLoading}
          dataSource={leadData}
          renderItem={(item, i) => {
            const isPinLeadFromLeadCenter =
              (selectedLeadsFromLeadCenter || []).findIndex(el => el?.id === item?.id) > -1;

            return (
              <ListItem
                item={item}
                selectedLead={selectedLead}
                setSummaryVisible={setSummaryVisible}
                user={user}
                isFromChatbot={isFromChatbot}
                sourcesData={sourcesData}
                activeOpp={activeOpp}
                setActiveOpp={oppr => {
                  setActiveOpp(oppr);
                  dispatch(changeMessageOpportunity(oppr));
                }}
                openAppointmentPopup={openAppointmentPopup}
                handleAppointmentModalClose={handleAppointmentModalClose}
                spinner={spinner}
                refetchLeads={refetchLeads}
                setAttachments={setAttachments}
                setmessageText={setmessageText}
                setSelectedLead={setSelectedLead}
                changePage={changePage}
                messageFilters={messageFilters}
                setMessageFilters={setMessageFilters}
                setShowLeadSection={setShowLeadSection}
                setOpportunityList={setOpportunityList}
                setFilterApplied={setFilterApplied}
                setSelectedLeadId={setSelectedLeadId}
                timeReference={timeReference}
                setbtnClicked={setbtnClicked}
                handleLeadListDrawer={handleLeadListDrawer}
                handleUnpinLead={handleUnpinLead}
                isPinLeadFromLeadCenter={isPinLeadFromLeadCenter}
                lang={lang}
                setLeadAsNoResponseNeeded={setLeadAsNoResponseNeeded}
                setNoResponseNeededLoading={setNoResponseNeededLoading}
                getDuplicateLeads={getDuplicateLeads}
                getMergedLead={getMergedLead}
                removeMergedLead={removeMergedLead}
                showAll={showAll}
                leadData={leadData}
                i={i}
                setShowAll={setShowAll}
                canMergeOppor={canMergeOppor}
                opportunityStatusList={opportunityStatusList}
              />
            );
          }}
        />
      </div>

      {!isEmpty(leadData) && leadCount > 5 && !leadsLoading && (
        <div className="sticky-pagination">
          <Pagination
            current={variables.page}
            pageSize={variables.pageSize}
            total={leadCount}
            align="center"
            pageSizeOptions={["5", "25", "50"]}
            showSizeChanger
            onChange={(page, pageSize) => {
              const newVariables = {
                ...variables,
                page,
                pageSize,
              };
              localStorage.removeItem("clickLeadId");
              setVariables(newVariables);
              setActiveOpp("#DEFAULTOPPID");
              handleScrollOnMovement();
              setSelectedLead({});
              localStorage.removeItem("changedLocationLeadId");
              setActiveLeadId(false);
              setLeadData([]);
            }}
            onShowSizeChange={(current, size) => {
              const newVariables = {
                ...variables,
                page: current,
                pageSize: size,
              };
              localStorage.removeItem("clickLeadId");
              setVariables(newVariables);
            }}
            size="small"
            className="!pb-1"
            showLessItems={window.location.pathname.includes("browser-ext") || width < 768}
          />
          <p className="text-center m-0 pb-2 text-base font-normal">
            {lang.total}: {leadCount} {leadCount === 1 ? lang.lead : lang.leads}
          </p>
        </div>
      )}
    </div>
  );
};

export default LeadListContainer;
function TopLeadFilters({
  lang,
  search,
  isFromChatbot,
  setSearchKey,
  setQueryString,
  handleSearch,
  setSearch,
  SortOptionsContainer,
  visible,
  handleVisibleChange,
  variables,
  setVariables,
  opportunityList,
  activeOpp,
  handleOppFilter,
  setActiveOpp,
  setShowLeadSection,
  selectedStatus,
  setSelectedStatus,
  leadStatus,
  handleStatusFilter,
  campaignFilters,
  queryString,
  entityId,
  eventId,
  filterCount,
  renderFilters,
  dispatch,
  selectedQuickFilters,
  backgroundColor,
}) {
  const updateVariableContext = () => {
    if (setVariables) {
      setVariables({
        ...variables,
        page: 1,
      });
    }
  };
  return (
    <div className="sticky top-0 bg-white z-[999]">
      <div className="flex items-center">
        <Input
          size="large"
          placeholder={lang.searchLeadBy}
          name="search"
          className="z-10 bg-white rounded-none "
          suffix={
            <>
              {!isEmpty(search) && (
                <AntdIconV4
                  type="CloseCircleOutlined"
                  onClick={() => {
                    isFromChatbot && window.parent.postMessage(search, "*");
                    setSearchKey("");
                    setQueryString("");
                    handleSearch("");
                    setSearch("");
                    localStorage.setItem("previousLeadSearchTrack", "");
                    // window.history.pushState("", "", `/engagements/activity-center`);
                  }}
                  className="cursor-pointer text-white text-[14px] mr-[5px] rounded-full bg-[#999696]"
                />
              )}
              <Tooltip title={lang.searchLeadBy}>
                <AntdIconV4
                  type="SearchOutlined"
                  onClick={() => {
                    localStorage.setItem("previousLeadSearchTrack", "");
                    search && handleSearch(search);
                  }}
                  className="cursor-pointer"
                />
              </Tooltip>
            </>
          }
          value={search}
          onChange={e => {
            // dispatch(setSelectedLeadPhone(e.target.value));
            if (isEmpty(e.target.value)) {
              if (window.location.pathname.includes("browser-ext")) {
                window.history.pushState("", "", `/browser-ext/`);
              } else {
                window.history.pushState("", "", `/engagements/activity-center`);
              }
            }
            setSearch(e.target.value);
          }}
        />
        <Popover trigger="click" placement="right" content={<SortOptionsContainer />}>
          <Button className="mx-1 flex items-center gap-2 rounded-none h-[39px]">
            {/* {!isBrowserExt && "Sort"} */}
            <SortIcon />
          </Button>
        </Popover>
        <Popover
          placement="right"
          title={<CustomLabel label={lang.leadFilters} labelClass="font-semibold" />}
          open={visible}
          onOpenChange={handleVisibleChange}
          content={
            <LeadFilterBreadcrumbs
              variables={variables}
              setVariables={setVariables}
              setSearchKey={setSearchKey}
              opportunityList={opportunityList}
              activeOpp={activeOpp}
              handleOppFilter={handleOppFilter}
              setActiveOpp={setActiveOpp}
              setShowLeadSection={setShowLeadSection}
              selectedStatus={selectedStatus}
              setSelectedStatus={setSelectedStatus}
              leadStatus={leadStatus}
              handleStatusFilter={handleStatusFilter}
              handleVisibleChange={handleVisibleChange}
              isFromChatbot={isFromChatbot}
              campaignFilters={campaignFilters}
              queryString={queryString}
              entityId={entityId}
              eventId={eventId}
            />
          }
          trigger="click"
        >
          <Tooltip placement="topLeft" title={lang.moreLeadFilters}>
            <Button className="flex items-center gap-2 rounded-none h-[39px]">
              {/* {!isBrowserExt && "Filter"} */}
              <Badge count={filterCount} className="mt-2">
                <FilterIcon />
              </Badge>
            </Button>
          </Tooltip>
        </Popover>
      </div>
      <div className="flex-col-centered gap-1">
        <div className="flex items-center my-1 justify-between w-full">
          <Dropdown
            menu={{
              items: renderFilters,
            }}
            trigger="click"
          >
            <div className="flex-row-centered gap-2 cursor-pointer items-center">
              <CustomLabel label={lang.quickFilters} labelClass="font-normal text-[14px]" />{" "}
              <DownIcon />
            </div>
          </Dropdown>
          <Button
            onClick={() => {
              updateVariableContext();
              dispatch(resetLeadFilters());
            }}
            type="text"
            className="text-blue-500"
          >
            Clear all
          </Button>
        </div>
        {selectedQuickFilters.length > 0 && (
          <div className="flex-row-centered mb-1 mr-1">
            {(selectedQuickFilters || []).slice(0, 2).map((item, index) => {
              const filter = leadStatus.find(status => status.id === item);
              return (
                <Tag
                  className={`cursor-pointer flex-row-centered gap-1 border-none ${backgroundColor(
                    filter.id
                  )}`}
                  onClose={() => {
                    updateVariableContext();
                    dispatch(removeQuickFilter(filter.id));
                    if (filter.id === "MY_CONVERSATIONS") dispatch(removeMyConversationFlag());
                  }}
                  key={index}
                >
                  <span>{filter.name}</span>{" "}
                  <CloseOutlined
                    className="cursor-pointer"
                    onClick={() => {
                      updateVariableContext();
                      dispatch(removeQuickFilter(filter.id));
                      if (filter.id === "MY_CONVERSATIONS") dispatch(removeMyConversationFlag());
                    }}
                  />
                </Tag>
              );
            })}
            {(selectedQuickFilters || []).length > 2 && (
              <Dropdown
                menu={{
                  items: renderFilters,
                }}
                trigger="click"
              >
                <Tag className="cursor-pointer">+ {(selectedQuickFilters || []).length - 2}</Tag>
              </Dropdown>
            )}
          </div>
        )}
        <div className="h-[1px] mb-1 w-full bg-grey-200" />
      </div>
    </div>
  );
}

const findLastMessage = (messages, n = 0) => {
  // Base case: If the index is out of range, return null.
  if (n >= messages.length) return null;
  const message = messages[n];
  // Check if the message is valid and has non-empty content.
  if (message !== undefined && message !== null && message?.content !== "") {
    return message;
  }
  // Recursively check the next message.
  return findLastMessage(messages, n + 1);
};

function ListItem({
  item,
  selectedLead,
  setSummaryVisible,
  user,
  isFromChatbot,
  sourcesData,
  activeOpp,
  setActiveOpp,
  openAppointmentPopup,
  handleAppointmentModalClose,
  spinner,
  refetchLeads,
  setAttachments,
  setmessageText,
  setSelectedLead,
  changePage,
  messageFilters,
  setMessageFilters,
  setShowLeadSection,
  setOpportunityList,
  setFilterApplied,
  setSelectedLeadId,
  timeReference,
  setbtnClicked,
  handleLeadListDrawer,
  lang,
  setNoResponseNeededLoading,
  setLeadAsNoResponseNeeded,
  isPinLeadFromLeadCenter,
  handleUnpinLead,
  getDuplicateLeads = () => {},
  getMergedLead = () => {},
  removeMergedLead = () => {},
  showAll,
  leadData,
  i,
  setShowAll,
  canMergeOppor,
  opportunityStatusList,
}) {
  const [showArchive, setshowArchive] = useState(false);
  const sortedMessages = (item?.messages || [])
    .map(el => ({ ...el, recentDate: el?.dateReceived || el?.dateSent }))
    .sort((a, b) => {
      const dateA = dayjs(a?.recentDate);
      const dateB = dayjs(b?.recentDate);
      return dateB.isBefore(dateA) ? -1 : 1;
    });

  const lastMessage = findLastMessage(sortedMessages || [], 0);
  return (
    <>
      <List.Item
        key={item?.id}
        className={`leadBox border-solid border-l-[6px] border-[1px] mt-3 p-3 mr-2 rounded-[4px] ${
          selectedLead && +selectedLead?.id === +item?.id ? "selectedLead" : "none"
        } ${item.isDeleted ? "bg-[#FEF2F2]" : ""}`}
        onMouseEnter={() => setshowArchive(true)}
        onMouseLeave={() => setshowArchive(false)}
        style={{
          borderLeftColor: colorCode[item?.messageStatusType?.status]
            ? colorCode[item?.messageStatusType?.status]
            : "#22C55E",
        }}
        onClick={() => {
          setSummaryVisible &&
            setSummaryVisible({
              visible: false,
              count: 0,
            });
        }}
      >
        <List.Item.Meta
          title={
            <TitleComponent
              item={item}
              lang={lang}
              showArchive={showArchive}
              setNoResponseNeededLoading={setNoResponseNeededLoading}
              setLeadAsNoResponseNeeded={setLeadAsNoResponseNeeded}
              isPinLeadFromLeadCenter={isPinLeadFromLeadCenter}
              handleUnpinLead={handleUnpinLead}
              opportunityStatusList={opportunityStatusList}
            />
          }
          description={
            <LeadList
              messageObject={lastMessage}
              user={user}
              item={item}
              isFromChatbot={isFromChatbot}
              sourcesData={sourcesData}
              activeOpp={activeOpp}
              setActiveOpp={setActiveOpp}
              openAppointmentPopup={openAppointmentPopup}
              handleAppointmentModalClose={handleAppointmentModalClose}
              spinner={spinner}
              selectedLeadId={selectedLead?.id}
              refetchLeads={refetchLeads}
              selectedLead={selectedLead}
            />
          }
          onClick={() => {
            setAttachments([]);
            setmessageText("");
            if (selectedLead?.id === item?.id) {
              return;
            }
            const itemData = { ...item };
            localStorage.getItem("changedLocationLeadId") &&
              localStorage.removeItem("changedLocationLeadId");
            itemData.unreadCount = 0;
            console.log();
            setSelectedLead(itemData);

            changePage();

            const dummyPayload = { ...messageFilters };
            delete dummyPayload.leadOpportunityId;
            setMessageFilters({
              ...dummyPayload,
              page: 1,
              leadId: item?.id,
              lastId: "",
            });
            setShowLeadSection(false);
            setOpportunityList([
              {
                filterId: null,
                id: "#DEFAULTOPPID",
                name: "All",
              },
            ]);
            setFilterApplied(false);
            setActiveOpp("#DEFAULTOPPID");
            setSelectedLeadId(item?.id);
            clearTimeout(timeReference);
            setbtnClicked(false);
            handleLeadListDrawer();
          }}
        />
      </List.Item>
      {item?.potentialLeads?.length > 0 && (
        <div className="bg-[#E2E8F0] flex justify-center items-center mr-[8px]">
          <span className="text-[#EF4444]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={13}
              height={12}
              fill="none"
              className="mr-2"
            >
              <path
                fill="#EF4444"
                d="M12.5 4.5a.5.5 0 0 1-.336.473L1 8.856V11.5a.5.5 0 1 1-1 0V.5A.5.5 0 0 1 .664.028l11.5 4a.5.5 0 0 1 .336.472Z"
              />
            </svg>
            Duplicate record found for this lead.
          </span>
          {canMergeOppor && (
            <span
              className="text-[#3B82F6] ml-1 cursor-pointer"
              onClick={() => {
                getDuplicateLeads(item, item?.potentialLeads);
                setSelectedLeadId(item?.id);
              }}
            >
              Merge It
            </span>
          )}
        </div>
      )}
      {item?.mergeHistory?.length > 0 && (
        <div className="bg-[#334155] flex justify-center items-center mr-[8px]">
          <span className="text-[#FFF]">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={17}
              height={16}
              fill="none"
              className="mr-2"
            >
              <path
                fill="#fff"
                d="M16 6.5a.5.5 0 0 1-.336.473L4.5 10.856V13.5a.5.5 0 1 1-1 0v-11a.5.5 0 0 1 .664-.472l11.5 4A.5.5 0 0 1 16 6.5Z"
              />
            </svg>
            This is merged lead
          </span>
          <span
            className="text-[#93C5FD] ml-1 cursor-pointer"
            onClick={() => {
              if (showAll[i]) getMergedLead(item, item?.mergeHistory, leadData);
              else removeMergedLead(item?.mergeHistory, leadData);
              setShowAll(prev => prev.map((val, index) => (index === i ? !val : val)));
            }}
          >
            {showAll[i] ? "Show All" : "Close"}
          </span>
        </div>
      )}
    </>
  );
}

const TitleComponent = ({
  item,
  lang,
  setNoResponseNeededLoading,
  setLeadAsNoResponseNeeded,
  isPinLeadFromLeadCenter,
  handleUnpinLead,
  showArchive,
  opportunityStatusList,
}) => {
  const latestOpportunity = orderBy(
    item?.leadOpportunities || [],
    item => new Date(item?.updatedDate),
    "desc"
  )[0];
  let leadDate = item?.leadCreatedDate
    ? parseTimestamp(dayjs.utc(item?.leadCreatedDate).local())
    : parseTimestamp(new Date());

  const sortedMessages = (item?.messages || [])
    .map(el => ({ ...el, recentDate: el?.dateReceived || el?.dateSent }))
    .sort((a, b) => {
      const dateA = dayjs(a?.recentDate);
      const dateB = dayjs(b?.recentDate);
      return dateB.isBefore(dateA) ? -1 : 1;
    });

  if ((sortedMessages || []).length > 0) {
    const lastMsgLead = !isUndefined(sortedMessages[0]?.id) ? sortedMessages[0] : sortedMessages[1];
    leadDate = lastMsgLead?.dateReceived
      ? parseTimestamp(dayjs.utc(lastMsgLead?.dateReceived).local())
      : parseTimestamp(dayjs.utc(lastMsgLead?.dateSent).local());
  }

  return (
    <div className="flex flex-col">
      <div className="flex justify-between">
        <div className="flex-col-centered w-[70%] items-start justify-start">
          <Tooltip title={item?.fullName || ""}>
            <span className="text-grey-700 w-full ellipsis">{item?.fullName || ""}</span>
          </Tooltip>
          <Tooltip
            title={getOpportunityStatusPath(
              opportunityStatusList,
              latestOpportunity?.opportunityStatus?.id
            )}
          >
            <span className={`text-xs ${statusColor(latestOpportunity?.opportunityStatus?.name)}`}>
              {latestOpportunity?.opportunityStatus?.name}
            </span>
          </Tooltip>
        </div>
        <div className="flex-col-centered w-[30%] items-end">
          <CustomLabel
            label={<div className="text-[12px] font-[400]">{` ${leadDate}`}</div>}
            labelClass="text-[#333] text-end"
          />{" "}
          <span
            onClick={e => {
              e.stopPropagation();
              Modal.confirm({
                title: "Are you sure?",
                icon: <ExclamationCircleFilled />,
                content: (
                  <div
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: `${`${
                        item?.messageStatusType?.status !== "NO_RESPONSE_NEEDED"
                          ? lang.noResponseNeededConfirmationMessage
                          : lang.restoreConfirmationMessage
                      }`.replace("__leadName__", item?.fullName)}`,
                    }}
                  />
                ),
                onOk() {
                  setNoResponseNeededLoading(true);
                  console.log("Called");
                  setLeadAsNoResponseNeeded({
                    variables: {
                      leadId: item?.id,
                      isNoResponseNeeded: item?.messageStatusType?.status !== "NO_RESPONSE_NEEDED",
                    },
                  });
                },
                onCancel() {
                  console.log("Cancel");
                },
              });
            }}
            className={`cursor-pointer flex-row-centered gap-1 items-center ${
              item?.messageStatusType?.status === "NO_RESPONSE_NEEDED" || showArchive
                ? "visible"
                : "invisible"
            }`}
          >
            {item?.messageStatusType?.status === "NO_RESPONSE_NEEDED" ? (
              <RestoreArchiveIcon />
            ) : (
              <ArchiveIcon />
            )}
            <span className="text-xs font-[400] text-brand-600">
              {item?.messageStatusType?.status === "NO_RESPONSE_NEEDED" ? "Restore" : "Archive"}
            </span>
          </span>
        </div>

        {isPinLeadFromLeadCenter && (
          <Tooltip title="Remove lead">
            <AntdIconV4
              type="PushpinFilled"
              style={{ color: "#334155" }}
              ml={4}
              onClick={() => handleUnpinLead(item)}
            />
          </Tooltip>
        )}
      </div>

      <div className="w-full my-2 h-[1px] bg-[#cbd5e1]" />
    </div>
  );
};
